PegasusTemplate.HistoryOperationsController = Em.ObjectController.extend({
  actions: {
    didExecute: function(){
      this.get('controllers.blockOperations').set('content', null);
      this.get('controllers.rowOperations').set('content', null);
    },
    didUnexecute: function(){
      this.get('controllers.blockOperations').set('content', null);
      this.get('controllers.rowOperations').set('content', null);
    },
  },
  needs: ['blockOperations', 'rowOperations']
});
